<template>
  <v-container id="clientFiler" class="filer py-0" v-if="!requireOnlyItems">
    <client-filer-toolbar ref="toolbar"
      :lib="getLibrary"
      :status="getStatus"
      :fixed="!!$props.fixedRoot"
      @emit="emitted"
    />
    <v-list class="files-wrap pb-0">
      <v-list-tile v-if="$vuetify.breakpoint.smAndUp">
        <v-list-tile-avatar></v-list-tile-avatar>
        <v-list-tile-content>
          <v-container grid-list-md class="pa-0">
            <v-layout wrap class="transparent">
              <v-flex xs8 class="order-link-wrap font-weight-bold blue-grey--text text--darken-3 pa-0">
                <span v-if="isSimple" class="order-link">名前</span>
                <button v-else type="button" @click="order('name')" class="order-link btn">
                  <span>名前</span>
                  <span v-if="currentOrderField === 'name'"><font-awesome-icon :icon="currentOrderDirectionIcon"/></span>
                </button>
              </v-flex>
              <v-flex xs2 class="font-weight-bold blue-grey--text text--darken-3 pa-0">
                <span v-if="isSimple" class="order-link">更新日</span>
                <button v-else type="button" @click="order('modified_at')" class="order-link btn">
                  <span>更新日</span>
                  <span v-if="currentOrderField === 'date'"><font-awesome-icon :icon="currentOrderDirectionIcon"/></span>
                </button>
              </v-flex>
              <v-flex xs2 class="font-weight-bold blue-grey--text text--darken-3 pa-0">
                <span v-if="isSimple" class="order-link">サイズ</span>
                <button v-else type="buton" @click="order('size')" class="order-link btn">
                  <span>サイズ</span>
                  <span v-if="currentOrderField === 'size'"><font-awesome-icon :icon="currentOrderDirectionIcon"/></span>
                </button>
              </v-flex>
            </v-layout>
          </v-container>
        </v-list-tile-content>
        <v-list-tile-action></v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-list :class="['items', { dropping: isDropping }]">
      <v-progress-linear v-if="isLoading" class="ma-0" indeterminate color="blue"></v-progress-linear>
      <template v-for="(item, idx) in getItems">
        <v-divider v-if="idx !== 0" :key="item.id + '_div'"></v-divider>
        <FilerFile v-if="item.type === 'file'"
          ref="item"
          :key="item.id"
          :cid="getClientId"
          :authed="$refs.toolbar.isAuthed && !$refs.toolbar.isRootShared"
          :shared="$refs.toolbar.hasSharedDirectory"
          :trashed="$refs.toolbar.isTrashed"
          :status="getStatus"
          :item="item"
          :selectable="$props.selectable == null || $props.selectable"
          @emit="emitted"
        />
        <FilerFolder v-if="item.type === 'folder'"
          ref="item"
          :key="item.id"
          :cid="getClientId"
          :authed="$refs.toolbar.isAuthed && !$refs.toolbar.isRootShared"
          :shared="$refs.toolbar.hasSharedDirectory"
          :trashed="$refs.toolbar.isTrashed"
          :status="getStatus"
          :item="item"
          :selectable="$props.selectable == null || $props.selectable"
          @emit="emitted"
        />
      </template>
      <v-list-tile v-if="getItems.length === 0 && !isSimple && !isLoading" class="grey--text text--darken-2">このフォルダは空です</v-list-tile>
    </v-list>
    <v-bottom-sheet :value="isDropping" hide-overlay>
      <v-list :class="isLocked ? 'red white--text' : 'blue darken-2 white--text'">
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>{{ isLocked ? 'このフォルダにはアップロードできません。' : 'ファイルをドロップしてアップロードできます。'}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-bottom-sheet>
    <div class="ghost body-1 blue white--text pa-2" ref="ghost">{{ printGhost }}</div>
    <RenameModal ref="renamer" @emit="emitted"></RenameModal>
    <PreviewModal ref="previewer" @emit="emitted"></PreviewModal>
    <MkdirModal ref="mkdirer" @emit="emitted"></MkdirModal>
    <ShareModal ref="sharer" @emit="emitted" />
    <ConfirmModal ref="confirmer" @emit="emitted"></ConfirmModal>
  </v-container>
  <v-list v-else :class="['items', { dropping: isDropping }]" style="width:100%;">
    <v-progress-linear v-if="isLoading" class="ma-0" indeterminate color="blue"></v-progress-linear>
    <template v-for="(item, idx) in getItems">
      <v-divider v-if="idx !== 0" :key="item.id + '_div'"></v-divider>
      <FilerFile v-if="item.type === 'file'"
        ref="item"
        :key="item.id"
        :cid="getClientId"
        :authed="$props.authed"
        :shared="$props.shared"
        :trashed="$props.trashed"
        :status="getStatus"
        :item="item"
        :selectable="$props.selectable == null || $props.selectable"
        @emit="emitted"
      />
      <FilerFolder v-if="item.type === 'folder'"
        ref="item"
        :key="item.id"
        :cid="getClientId"
        :authed="$props.authed"
        :shared="$props.shared"
        :trashed="$props.trashed"
        :status="getStatus"
        :item="item"
        :selectable="$props.selectable == null || $props.selectable"
        @emit="emitted"
      />
    </template>
    <v-list-tile v-if="getItems.length === 0 && !isLoading" class="grey--text text--darken-2">何のアイテムもありません</v-list-tile>
    <RenameModal ref="renamer" @emit="emitted" />
    <PreviewModal ref="previewer" @emit="emitted" />
    <MkdirModal ref="mkdirer" @emit="emitted" />
    <ShareModal ref="sharer" @emit="emitted" />
    <ConfirmModal ref="confirmer" @emit="emitted" />
  </v-list>
</template>

<script>
import ClientFilerToolbar from './toolbar'
import FilerFolder from '../components/folder'
import FilerFile from '../components/file'
import RenameModal from '../components/modals/rename'
import PreviewModal from '../components/modals/preview'
import MkdirModal from '../components/modals/mkdir'
import ShareModal from '../components/modals/share'
import ConfirmModal from '@/components/modals/confirm'
const DEF = {
  STATUS: {
    PERSONAL: false,
    LOADING: false,
    DRAGGING: false,
    DROPPING: false,
    LOCKED: false,
    CD: null,
    PERMITS: JSON.stringify({
      add: true,
      modify: true,
      trash: true,
      root: false
    })
  },
  FORM: {
    ORDER: {
      FIELD: 'name',
      DIR: 'asc'
    }
  }
}
export default {
  name: 'clientFiler',
  components: {
    ClientFilerToolbar,
    FilerFolder,
    FilerFile,
    RenameModal,
    PreviewModal,
    MkdirModal,
    ShareModal,
    ConfirmModal
  },
  props: [
    'cid',
    'rid',
    'type',
    'authed',
    'items',
    'filters',
    'permits',
    'selectable',
    'fixedRoot',
    'showOnlyItems'
  ],
  data () {
    return {
      config: {
        status: {
          loading: DEF.STATUS.LOADING,
          dragging: DEF.STATUS.DRAGGING,
          dropping: DEF.STATUS.DROPPING,
          locked: DEF.STATUS.LOCKED,
          permits: {}
        }
      },
      meta: {
        status: {
          media: {
            adding: true,
            modifying: true,
            trash: true,
            copying: ''
          },
          trash: {
            adding: false,
            modifying: false,
            trash: false,
            copying: ''
          },
          arrange: {
            adding: false,
            modifying: false,
            trash: true,
            copying: ''
          }
        },
        order: {
          dir: {
            asc: ['fal', 'sort-numeric-down'],
            desc: ['fal', 'sort-numeric-up']
          }
        }
      },
      form: {
        order: {
          field: DEF.FORM.ORDER.FIELD,
          dir: DEF.FORM.ORDER.DIR
        }
      },
      store: {
        lib: {},
        items: [],
        ghost: ''
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init: function (req) {
      const { authed } = !req ? this.$props : req
      this.get({
        id: -1,
        type: 'shared',
        tags: {
          authed: !!authed
        }
      })
    },
    emitted: function (req) {
      if (
        req &&
        req.action &&
        typeof this[req.action] === 'function'
      ) {
        this[req.action](req.data)
      }
    },
    open: function (item) {
      if (
        item &&
        item.id &&
        item.type
      ) {
        if (item.type === 'file') {
          this.$refs.previewer.open(item)
        } else if (item.type === 'folder') {
          this.get(item)
        }
      }
    },
    get: function (dest) {
      const urls = {
        shared: `${this.$url.api}user/box/get/shared`,
        folder: `${this.$url.api}user/box/get/client/folder/${dest.id}`
      }
      if (dest && dest.type) {
        const url = !urls[dest.type] ? urls.folder : urls[dest.type]
        this.$set(this.config.status, 'loading', true)
        this.axios.post(url, {
          options: this.form
        }, {
          headers: {
            'user-token': this.$localStorage.get('jwt')
          }
        }).then(res => {
          console.log(res)
          if (res.data && res.data.success) {
            this.$set(this.store, 'items', res.data.data)
            if (this.$refs.toolbar) {
              this.$refs.toolbar.forward(dest)
            }
          }
          this.$set(this.config.status, 'loading', false)
        }).catch(err => {
          console.log(err)
        })
      }
    },
    order: function (field) {
      if (field) {
        if (this.form.order.field === field) {
          this.$set(this.form.order, 'dir', (this.form.order.dir === 'asc') ? 'desc' : 'asc')
        } else {
          this.$set(this.form.order, 'field', field)
        }
      }
    },
    select: function (req) {
      if (
        req &&
        req.item &&
        req.event
      ) {
        let item = req.item
        let e = req.event
        let sidx = this.$refs.item.findIndex(it => {
          return (it.item && it.item.id && it.item.id === item.id)
        })
        if (sidx >= 0) {
          if (e.shiftKey) {
            let idx = -1
            let i = -1
            i = sidx + 1
            while (i < this.$refs.item.length && idx === -1) {
              idx = this.$refs.item[i].isSelecting ? i : idx
              i += 1
            }
            i = sidx - 1
            while (i >= 0 && idx === -1) {
              idx = this.$refs.item[i].isSelecting ? i : idx
              i -= 1
            }
            let st = Math.min(sidx, Math.max(idx, 0))
            let ed = Math.max(sidx, idx)
            for (let i = st; i <= ed; i++) {
              if (this.$refs.item[i].isActive) {
                this.$refs.item[i].state({
                  type: 'selecting',
                  status: true
                })
              }
            }
          } else if (!e.metaKey) {
            for (let i = 0; i < this.$refs.item.length; i++) {
              let it = this.$refs.item[i]
              if (it.item && it.item.id && it.item.id !== item.id) {
                this.$refs.item[i].state({
                  type: 'selecting',
                  status: false
                })
              }
            }
          }
          let selects = this.$refs.item.filter(it => {
            return it.isSelecting
          }).map(it => {
            return it.item
          })
          this.$emit('select', selects)
        }
      }
    }
  },
  computed: {
    isSimple () {
      return !!this.$props.items
    },
    requireOnlyItems () {
      return this.$props.showOnlyItems
    },
    isLoading () {
      return this.config.status.loading
    },
    isDropping () {
      return this.config.status.dropping
    },
    isLocked () {
      return this.config.status.locked
    },
    isSetClientId () {
      return (this.$props.cid || this.$route.params.id)
    },
    getClientId () {
      return !this.$props.cid ? this.$route.params.id : this.$props.cid
    },
    getStatus () {
      return this.config.status
    },
    getLibrary () {
      return this.store.lib
    },
    getItems () {
      let items = !this.$props.items ? this.store.items : this.$props.items
      return items.map(it => {
        if (it.name && it.type) {
          return {
            id: it.id,
            name: it.name,
            type: it.type,
            size: it.size,
            modified_at: it.modified_at,
            active: (!(
              this.$props.filters &&
              this.$props.filters.extensions &&
              this.$props.filters.extensions.length &&
              !this.$props.filters.extensions.includes(it.extension)
            ) && !(
              this.$props.filters &&
              this.$props.filters.ids &&
              this.$props.filters.ids.length &&
              this.$props.filters.ids.includes(it.id)
            )) || (it.type === 'folder')
          }
        } else {
          return {}
        }
      }).sort((a, b) => {
        if (this.form.order.dir === 'asc') {
          return a[this.form.order.field] > b[this.form.order.field] ? 1 : -1
        } else {
          return a[this.form.order.field] < b[this.form.order.field] ? 1 : -1
        }
      })
    },
    currentOrderField () {
      return this.form.order.field
    },
    currentOrderDirectionIcon () {
      return this.meta.order.dir[this.form.order.dir] ? this.meta.order.dir[this.form.order.dir] : []
    },
    printGhost () {
      return this.store.ghost
    }
  }
}
</script>

<style lang="scss">
.filer {
  .order-link {
    position: relative;
    display: block;
    width: 100%;
    height: $form_h;
    line-height: $form_h;
    text-align: left;
    padding-left: 1rem;
    &.btn {
      outline: 0 !important;
      &:hover {
        background: rgba(#000, .1);
      }
    }
  }
  .items {
    border-top: 1px solid rgba(#000, .12);
    &.dropping {
      border: 1px dashed rgba(#000, .8);
      opacity: .3;
    }
  }
  .ghost {
    position: absolute;
    top: -100%;
    left: -100%;
    border: 1px solid $white;
    border-radius: 2px;
  }
}
</style>
